<template>
  <section>
    <Card :no-card="noCard">
      <!-- TODO -->
      <div v-if="loading">
        <Spinner />
      </div>
      <div v-else-if="hasZapierConnection">
        <p>{{ 'Zapier is enabled.' }}</p>
        <div class="flex flex-row justify-between">
          <Btn tag="button" size="sm" @click="disconnect">
            {{ 'Disconnect account' }}
          </Btn>
        </div>
        <div v-if="testResult">
          <pre><code>{{ testResult }}</code></pre>
        </div>
      </div>
      <FormGrouping v-else>
        <p>
          {{
            'Create Zapier email automations using MailSlurp. Connect your Zapier account to enable integration.'
          }}
        </p>
        <div>
          <Btn
            rel="noopener noreferer"
            size="sm"
            icon="zapier"
            tag="a"
            href="https://zapier.com/apps/mailslurp-email-plugin/integrations"
            target="_blank"
            >{{ 'Connect Zapier account' }}
          </Btn>
        </div>
      </FormGrouping>
    </Card>
    <div v-if="hasZapierConnection">
      <NewEmailRecordsTable classes="mb-3" />
      <NewAttachmentRecordsTable classes="mb-3" />
      <NewContactRecordsTable />
    </div>
  </section>
</template>
<script setup lang="ts">
import NewEmailRecordsTable from '../../components/zapier/NewEmailRecordsTable.vue';
import NewAttachmentRecordsTable from '../../components/zapier/NewAttachmentRecordsTable.vue';
import { loadFetch } from '../../lib/services/helpers';
import NewContactRecordsTable from '../../components/zapier/NewContactRecordsTable.vue';
import Spinner from '../../components/Spinner.vue';
import { onMounted, computed, ref } from 'vue';
import Btn from '../form/Btn.vue';
import { useStore3 } from '../../store/main';
import { storeToRefs } from 'pinia';
import FormGrouping from '../form/FormGrouping.vue';
import Card from '../../components/tw/Card.vue';

const store3 = useStore3();
withDefaults(defineProps<{ noCard?: boolean }>(), {
  noCard: false,
});

const loading = ref<boolean>(false);
const testResult = ref<string | null>(null);

const { zapierConnection } = storeToRefs(store3);
const hasZapierConnection = computed<boolean>(() => {
  return zapierConnection.value?.hasConnection ?? false;
});

const disconnect = async () => {
  await loadFetch(() => store3.deleteZapierConnection(), store3, loading);
  await refresh();
};

const refresh = async () => {
  await loadFetch(() => store3.getZapierConnection(), store3, loading);
};

onMounted(async () => {
  await refresh();
});
</script>
